import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MmitaAsset } from '../_models/mmitaAsset';
import { AssetReadDto } from '../_models/assetReadDto';
import { AssetWriteDto } from '../_models/assetWriteDto';
import { InfiniteResult } from '../_models/body';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MmitaAssetService {
  httpOptions: any = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  formOptions: any = { headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }) };

  constructor(
    private http: HttpClient
  ) {
  }

  getAll(params?: any) {
    let para = {}
    if (params) {
      for (let prop in params) {
        Object.assign(para, { [prop]: params[prop] });
      }
    }
    return this.http.get<InfiniteResult>(`${environment.apiEndpoint}api/Asset/Query`, {
      params: para
    });
  }

  getById(id: string) {
    return this.http.get<AssetReadDto>(`${environment.apiEndpoint}api/Asset/${id}`);
  }

  addAsset(request: AssetWriteDto) {
    return this.http.post(`${environment.apiEndpoint}api/Asset`, request)
  }

  batchaddAsset(request: Array<AssetWriteDto>) {
    return this.http.post(`${environment.apiEndpoint}api/Assets`, request)
  }


  batchDelete(assetsIdList: any) {
    return this.http.request<any>('delete', `${environment.apiEndpoint}api/Assets`, {
      body: assetsIdList,
      headers: this.formOptions,
      observe: 'body',
    })
  }

  updateAsset(request: AssetWriteDto, id: string) {
    return this.http.put(`${environment.apiEndpoint}api/Asset/${id}`, request)
  }

  batchUpdateAbility(req: any) {
    return this.http.put(`${environment.apiEndpoint}api/Assets/Abilities`, req)
  }

  delete(id: string) {
    return this.http.delete<MmitaAsset>(`${environment.apiEndpoint}api/Asset/${id}`);
  }

  predelete(ids: Array<string>) {
    return this.http.delete<MmitaAsset>(`${environment.apiEndpoint}api/Assets/predelete`, { body: { ids: ids } });
  }

  getMapPlaceAsset(params: any) {
    return this.http.get<InfiniteResult>(`${environment.apiEndpoint}api/Asset/Query?${params}`, {
      params: {
        'PageSize': '-1'
      }
    });
  }


  getSketchfabAccessToken() {
    return this.http.get(`${environment.apiEndpoint}api/Asset/Sketchfab/AccessToken`)
  }

  postSketchfabAccessToken() {
    return this.http.post(`${environment.apiEndpoint}api/Asset/Sketchfab/AccessToken`, null)
  }

  setDefaultAiBuddy(id: string) {
    return this.http.put(`${environment.apiEndpoint}api/Asset/AiBuddy/${id}/SetDefault`, null)
  }

  getLibrary() {
    return this.http.get(`${environment.apiEndpoint}api/Asset/Library/Query`)
  }


  previewLibrary(data: any) {
    return this.http.post(`${environment.apiEndpoint}api/Asset/Library/Preview`, data)
  }

  updateLibrary(data: any) {
    return this.http.put(`${environment.apiEndpoint}api/Asset/Library`, data)
  }

  getEventCategories() {
    return this.http.get(`${environment.apiEndpoint}api/Asset/Library/EventCategories`)
  }

  updateEventCategories(data: any) {
    return this.http.put(`${environment.apiEndpoint}api/Asset/Library/EventCategories`, data)
  }

  deleteEventCategory(key: string, deleteAssetArray?: Array<string>) {
    const params = new HttpParams().set('listKey', key);
    return this.http.put(`${environment.apiEndpoint}api/Asset/Library/EventCategories/Remove`, deleteAssetArray, { params });
  }

  getEventCategoriesByAssetId(assetId: string) {
    return this.http.get(`${environment.apiEndpoint}api/Asset/Library/EventCategories/Attached/${assetId}`)
  }

  updateAttachEventCategory(key: string, data: any) {
    const params = new HttpParams().set('listKey', key);
    return this.http.put(`${environment.apiEndpoint}api/Asset/Library/EventCategories/Attach`, data, { params });
  }

}
